<template>
  <div class="has-text-left">
    <div
      class="field"
      v-if="User.info.country_code !== 'JP'"
    >
      <div class="control">
        <label
          class="label"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{translations.text.bankName}}</label>
        <span class="select">
          <select v-model="bank_code">
            <option
              selected
              value
            >{{translations.text.select.tCapitalizeFirstLetter()}}</option>
            <option
              v-for="(bank, code) in banks[User.info.country_code]"
              :value="code"
              :key="code"
            >{{bank.tCapitalizeFirstLetter()}}</option>
          </select>
        </span>
      </div>
    </div>

    <div v-if="User.info.country_code == 'JP' || bank_code != ''">
      <div class="field">
        <p class="control">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >Account No.</label>
          <input
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('accNo') }"
            name="accNo"
            type="text"
            :data-vv-as="translations.text.accountNo"
            :placeholder="translations.text.accountNo"
            v-model="acc_no"
          />
          <span
            v-show="errors.has('accNo')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('accNo') }}</span>
        </p>
      </div>
      <div class="field">
        <p class="control">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >Name on account</label>
          <input
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('accName') }"
            name="accName"
            type="text"
            :data-vv-as="translations.text.accountName"
            :placeholder="translations.text.accountName"
            v-model="acc_name"
          />
          <span
            v-show="errors.has('accName')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('accName') }}</span>
        </p>
      </div>
      <div class="field">
        <p class="control">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >Routing No.</label>
          <input
            :class="{ input: true, 'is-danger': errors.has('routingNo') }"
            name="routingNo"
            type="text"
            :data-vv-as="translations.text.routingNo"
            :placeholder="translations.text.routingNo"
            v-model="routing_no"
          />
          <span
            v-show="errors.has('routingNo')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('routingNo') }}</span>
        </p>
      </div>
      <br />
      <br />
    </div>

    <div v-if="User.info.country_code == 'JP' || bank_code != ''">
      <h5
        class="title"
        v-if="!amountLocked"
      >{{$t("please_enter_amount_withdraw").tUpper()}}</h5>

      <div class="field has-addons">
        <p class="control">
          <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
        </p>
        <p class="control">
          <input
            v-validate="'required|currency|min_value:65'"
            :class="{'input': true, 'is-danger': errors.has('amount') }"
            name="amount"
            type="text"
            :data-vv-as="translations.text.amount"
            :placeholder="translations.text.amount"
            v-model="amount"
          />
          <span
            v-show="errors.has('amount')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('amount') }}</span>
        </p>
        <p class="control">
          <a
            class="button is-success"
            @click="withdraw"
          >
            <span class="icon is-small">
              <i
                class="fa fa-check"
                :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
              ></i>
            </span>
            <span>{{$t("withdraw").tTitle()}}</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../../../config'

export default {
  data() {
    return {
      amount: 0,
      amountLocked: false,
      amountExceeded: false,
      translations: {
        text: {
          amount: this.$t('amount'),
        },
      },
      currencySymbols: config.currencies,
      translations: {
        text: {
          amount: this.$t('amount').tTitle(),
          select: this.$t('select').tTitle(),
          bankName: this.$t('bank_name').tTitle(),
          accountNo: this.$t('account_no').tTitle(),
          routingNo: this.$t('routing_no').tTitle(),
          accountName: this.$t('beneficiary_name_on_account').tTitle(),
          currency: this.$t('currency'),
        },
      },
      acc_no: '',
      acc_name: '',
      routing_no: '',
      bank_code: '',
      bank_name: '',
      banks: {
        ID: {
          BAG: 'Bank Artha Graha',
          BBKP: 'Bank Bukopin',
          BCA: 'Bank Central Asia',
          BCW: 'Bank Commonwealth',
          BDM: 'Bank Danamon',
          BMG: 'Bank Mega',
          BMI: 'Maybank Indonesia',
          BMP: 'Bank Maspion',
          BMTK: 'Bank Mestika',
          BNI: 'Bank Negara Indonesia',
          BPN: 'Bank Panin',
          BRI: 'Bank Rakyat Indonesia',
          BSM: 'Bank Sinar Mas',
          BSMT: 'Bank Sumut',
          BTPN: 'Bank Btpn',
          CIMBN: 'CIMB Niaga',
          HSBCI: 'HSBC Indonesia',
          MDR: 'Bank Mandiri',
          PTB: 'Bank Permata',
          UOBI: 'UOB Indonesia',
          OCBCNP: 'Bank OCBC NISP',
        },
        MY: {
          AFB: 'Affin Bank Berhad',
          ALB: 'Alliance Bank',
          AMB: 'Ambank',
          BIM: 'Bank Islam Malaysia',
          BKR: 'Bank Rakyat',
          BSN: 'Bank Simpanan Nasional',
          CIMB: 'CIMB Bank',
          CITI: 'CITIBANK BERHAD',
          HLB: 'Hong Leong Bank',
          HSBC: 'HSBC BANK MALAYSIA BERHAD',
          MBB: 'Maybank Berhad',
          OCBC: 'OCBC BANK(MALAYSIA) BHD',
          PBB: 'Public Bank',
          RHB: 'RHB',
          SDCBM: 'STANDARD CHARTERED BANK',
          'UOB MSIA': ' UNITED OVERSEA BANK',
        },
        TH: {
          KTB: 'Krung Thai Bank',
          SCB: 'Siam Commercial Bank',
          BBL: 'Bangkok bank',
          KBANK: 'Kasikorn Bank',
          BAY: 'Krungsri Thai bank',
          UOB: 'UOB Bank',
          SDCB: 'Standard Chartered Bank',
          LHB: 'LAND AND HOUSES RETAIL BANK PUBLIC COMPANY LIMITED',
          GSB: 'Government Savings Bank',
          GHB: 'GHB GOVERNMENT HOUSING BANK',
          TTB: 'TMBThanachart Bank',
        },
        VN: {
          VCB: 'Vietcombank',
          VTB: 'Vietinbank',
          ACB: 'Asia Commercial Bank',
          EXIM: 'Eximbank',
          SCM: 'Sacombank',
          TCB: 'Techcombank',
          DAB: 'DongA Bank',
          BIDV: 'BIDV Bank',
          VBARD: 'Agribank',
        },
      },
    }
  },
  // watch: {},
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {},
  methods: {
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.amountLocked && this.amount > this.setAmount) {
            this.amountExceeded = true
            return
          }
          this.amountExceeded = false

          let wd_data = {
            currency: this.User.wallet.currency,
            acc_name: this.acc_name,
            acc_no: this.acc_no,
          }

          if (this.routing_no.length > 0) {
            wd_data.routing_no = this.routing_no
          }

          if (this.User.info.country_code == 'JP') {
            wd_data.bank_code = '3331'
            wd_data.bank_name = 'Kitakyushu Bank'
          } else {
            wd_data.bank_code = this.bank_code
            wd_data.bank_name = this.banks[this.User.info.country_code][this.bank_code]
          }

          console.log('wd_data:', wd_data)

          this.$bus.$emit('RequestWithdraw', '/finance/withdraw', {
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            psp: 'payneteasy',
            extraInfo: JSON.stringify(wd_data),
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Payneteasy.vue?a7de6e1c